import { redirect } from "react-router";

import { store } from "../../../../..";
import {
    getGame,
    getGameRatings,
    getLeague,
    getRoster,
} from "../../../../../lib/api";

const loader = async ({ params }: any) => {
    const { teamId, gameId } = params;
    const { game } = await getGame(gameId);

    if (
        game.home.id !== parseInt(teamId) &&
        game.visitor.id !== parseInt(teamId)
    ) {
        return redirect(`/coachs-clubhouse/team/${teamId}`);
    }

    const [
        { players: homeRoster },
        { players: visitorRoster },
        { ratings: umpireRatingsRaw },
    ] = await Promise.all([
        getRoster(game.home.id, game.league),
        getRoster(game.visitor.id, game.league),
        getGameRatings(gameId, "umpire"),
    ]);

    const user = store.getState().auth.user;
    const umpireRatings = umpireRatingsRaw.filter(
        r => r.ratedBy.id === parseInt(user!.id.toString()),
    );

    return {
        teamId,
        gameId,
        game,
        umpireRatings,
        homeRoster,
        visitorRoster,
    };
};

export default loader;
